import type { CmChecklist } from '@luxuryescapes/contract-svc-offer';

import type { DiscountsMarginRowView } from '../../tabs/discountsMargin/types';

export const DISCOUNTS_MARGIN_FIELDS: Record<CmChecklist.DiscountsMarginRuleId, DiscountsMarginRowView['field']> = {
  'offer-discounts': 'Offer discounts',
  'deal-option-margin-spread': 'Deal option margin spread',
  'flexi-margin-spread': 'Flexi deal option margin spread',
};

export function getOfferDiscountsRule(minPercent: number, maxPercent: number) {
  return `If any offer discount is greater than ${maxPercent}% or less than ${minPercent}%, flag for approval; otherwise auto-approve.`;
}

export function getMarginSpreadRule(thresholdPercent: number) {
  return `If the margin spread between any two deal options is ${thresholdPercent}% or more, flag for approval; otherwise auto-approve.`;
}

export function getMarginSpreadSummary({
  approved,
  comparableCount,
  flaggedOptionCount,
}: {
  approved: boolean;
  comparableCount: number;
  flaggedOptionCount: number;
}) {
  if (comparableCount < 2) {
    return 'Fewer than 2 deal options with a margin to compare.';
  }

  if (approved) {
    return 'All deal option margins are within the approved spread.';
  }

  return `Found ${flaggedOptionCount} outlier deal option${flaggedOptionCount === 1 ? '' : 's'}.`;
}
